import * as React from "react";
import ReferidosStepOne from "../stepOne";
import ReferidosStepTwo from "../stepTwo";
import ReferidosStepThree from "../stepThree";
import ReferidosStepConfirmacion from "../stepConfirmacion";

export default class ReferidosSwitch extends React.Component {
  state = {
    step: 1,
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  render() {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (
          <ReferidosStepOne
            handleClose={this.props.handleClose}
            handleScroll={this.props.handleScroll}
            nextStep={this.nextStep}
          ></ReferidosStepOne>
        );
      case 2:
        return (
          <ReferidosStepTwo
            handleClose={this.props.handleClose}
            handleScroll={this.props.handleScroll}
            nextStep={this.nextStep}
          ></ReferidosStepTwo>
        );
      case 3:
        return (
          <ReferidosStepThree
            handleClose={this.props.handleClose}
            handleScroll={this.props.handleScroll}
            nextStep={this.nextStep}
          ></ReferidosStepThree>
        );
      case 4:
        return (
          <ReferidosStepConfirmacion
            handleClose={this.props.handleClose}
            handleScroll={this.props.handleScroll}
          ></ReferidosStepConfirmacion>
        );
      default:
      // No hace nada
    }
  }
}
